// src/stores/auth.ts
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuthStore = defineStore('auth', () => {
  const token = ref<string | null>(localStorage.getItem('auth_token'))
  const role = ref<'superadmin' | 'user' | null>(localStorage.getItem('auth_role') as any)

  const setToken = (newToken: string, userRole: 'superadmin' | 'user') => {
    token.value = newToken
    role.value = userRole
    localStorage.setItem('auth_token', newToken)
    localStorage.setItem('auth_role', userRole)
  }

  const logout = () => {
    token.value = null
    role.value = null
    localStorage.removeItem('auth_token')
    localStorage.removeItem('auth_role')
  }

  return { token, role, setToken, logout }
})
